/**
 * [Yoast SEO FAQ] Add accordion support to Yoast SEO FAQ schema
 */

jQuery(document).ready(function ($) {
  var yoast = {
    accordion: function () {
      const accordion = $(".wp-block-yoast-faq-block"),
        sections = accordion.find(".schema-faq-section");

      accordion.addClass("accordion");
      sections.addClass("accordion-item");

      sections.each(function () {
        let question = $(this).find(".schema-faq-question"),
          answer = $(this).find(".schema-faq-answer"),
          id = $(this).attr("id");

        question.attr("id", id + "-header").addClass("accordion-header");
        question.html(
          '<button class="accordion-button collapsed px-0" type="button" data-bs-toggle="collapse" data-bs-target="#' +
            id +
            "-collapse" +
            '" aria-expanded="false" aria-controls="' +
            id +
            "-collapse" +
            '">' +
            question.text() +
            "</button>"
        );

        answer
          .attr("id", id + "-collapse")
          .attr("aria-labelledby", id + "-header")
          .attr("data-bs-parent", ".wp-block-yoast-faq-block")
          .addClass("accordion-collapse collapse m-0");
        answer.html('<div class="accordion-body">' + answer.text() + "</div>");
      });
      accordion.removeClass('loading');
    },
  };

  yoast.accordion();
});
